import { Controller } from "@hotwired/stimulus";
import { numberToCurrency } from "../../utils/number_utils";
import { roundToTwoDecimals } from "../../utils/number_utils";

export default class extends Controller {
  static targets = [
    "container",
    "totalDividendsAmount",
    "flatTaxAmount",
    "netDividendsAmount",
    "partialDividendsAmount",
  ];
  static values = {
    maximumDividends: Number,
    flatTaxRate: Number,
  };

  setMaximumDividends() {
    this.dividendsAmount = this.maximumDividendsValue;
  }

  setNoDividends() {
    this.dividendsAmount = 0;
  }

  setPartialDividends() {
    this.dividendsAmount = this.partialDividendsAmountTarget.value || 0;
  }

  manageExplanation() {
    if (this.dividendsAmount > 0) {
      this._fillExplanations();
      this._showExplanations();
    } else {
      this._hideExplanations();
    }
  }

  _showExplanations() {
    this.containerTarget.classList.remove("hidden");
  }

  _hideExplanations() {
    this.containerTarget.classList.add("hidden");
  }

  _fillExplanations() {
    this.totalDividendsAmountTarget.innerText = numberToCurrency(this.dividendsAmount);

    const taxAmount = this.dividendsAmount * this.flatTaxRateValue;
    this.flatTaxAmountTarget.innerText = numberToCurrency(taxAmount);

    const netDividendsAmount = this.dividendsAmount - roundToTwoDecimals(taxAmount);
    this.netDividendsAmountTarget.innerText = numberToCurrency(netDividendsAmount);
  }
}
